import {
    BreadthRebateProgramAction,
    BreadthRebateProgramResult,
    PostBreadthRebateProgramApiParameter,
    postBreadthRebateProgram,
} from "@dana/Services/BreadthRebateProgramService";
import { BreadthRebateProgramActions } from "@dana/Store/Data/BreadthRebateProgram/Reducers/BreadthRebateProgramReducer";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type Parameter = {
    action: BreadthRebateProgramAction;
    soldToId?: string;
} & HasOnSuccess<BreadthRebateProgramResult> &
    HasOnError<string>;

type HandlerType = ApiHandlerDiscreteParameter<
    Parameter,
    PostBreadthRebateProgramApiParameter,
    BreadthRebateProgramResult,
    BreadthRebateProgramActions
>;

export const SetLoadingOn: HandlerType = props => {
    props.dispatch({
        type: "BreadthRebateProgram/IsLoading",
        isLoading: true,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.apiParameter,
        action: props.parameter.action,
        soldToId: props.parameter.soldToId,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await postBreadthRebateProgram(props.apiParameter);
    } catch (error) {
        const message = error instanceof Error ? error.message : String(error);
        props.dispatch({
            type: "BreadthRebateProgram/FetchError",
            error: message,
        });
        props.parameter.onError?.(message);
        // stop the chain so onSuccess is never called for a failed request
        return false;
    }
};

export const PopulateResult: HandlerType = props => {
    props.dispatch({
        type: "BreadthRebateProgram/PopulateResult",
        data: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult!);
};

export const chain = [SetLoadingOn, PopulateApiParameter, RequestDataFromApi, PopulateResult, ExecuteOnSuccessCallback];

const postBreadthRebateProgramData = createHandlerChainRunner(chain, "PostBreadthRebateProgram");
export default postBreadthRebateProgramData;
